import React from 'react';
import { Box, SubmitButton } from '@staffino/primitive-controls';
import { useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import TextField from './text-field';
import TextPanel from './text-panel';

type Props = {
  feedbackId: string;
  customerId: string;
  customerImageUrl?: string;
  onSubmit: (message: {
    text: string;
    customerId: string;
    feedbackId: string;
    from: {
      id: string;
      isManager: boolean;
    };
    createdAt: Date;
  }) => void;
};

const ReplyForm = ({
  feedbackId,
  customerId,
  customerImageUrl,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  const { register, errors, watch, formState, setValue, handleSubmit } =
    useForm();
  const reply = watch('reply');
  const { isSubmitting } = formState;

  const createReply = async (values) => {
    onSubmit?.({
      text: values.reply,
      customerId,
      feedbackId,
      from: {
        id: customerId,
        isManager: false,
      },
      createdAt: new Date(),
    });
    try {
      const response = await fetch(`/api/feedback/${feedbackId}/create-reply`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          text: values.reply,
          participantId: customerId,
        }),
      });
      console.log('API response: ', response);
      setValue('reply', '');
    } finally {
      location.reload();
    }
  };

  return (
    <form onSubmit={handleSubmit(createReply)}>
      <Box
        mt={10}
        flexDirection="row"
        pl={[0, customerImageUrl ? 'unset' : '2.375rem']}
      >
        {/* <Avatar */}
        {/*  size="small" */}
        {/*  defaultSource={customerImageUrl} */}
        {/*  // borderRadius="0.1875rem" */}
        {/* /> */}
        <Box ml={[0, 15]} flex="1 1 auto">
          <TextField
            ref={register}
            type="singleline"
            name="reply"
            placeholder={t('Your reply')}
            style={{
              opacity: 0.5,
              borderRadius: '4px',
              border: 'solid 1px #a3b2bf',
              fontStyle: 'italic',
              height: '40px',
              fontSize: '0.874rem',
              padding: '10px',
            }}
          />
          {errors?.reply && (
            <TextPanel color="notification" mt={10}>
              {errors.reply}
            </TextPanel>
          )}
          <Box flexDirection="row" mt={10}>
            {!!reply && (
              <SubmitButton
                font-size={12}
                px={10}
                fontWeight="normal"
                disabled={isSubmitting}
                loading={isSubmitting}
              >
                <Trans>Reply</Trans>
              </SubmitButton>
            )}
          </Box>
        </Box>
      </Box>
    </form>
  );
};

export default ReplyForm;
